import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import {
  IconAlertCircle,
  IconArrowLeft,
} from "../../components/utils/Icons/CustomIcons"
import { useAppDispatch, useAppSelector } from "../../redux/store"
import { ToastContainer, toast } from "react-toastify"
import api from "@/api/api"
import {
  setUploadedImage,
  toggleNumberOutside,
  setChooseType,
  resetInvitationState,
} from "@/redux/slices/invite/invitationSlice"
import { FaBedPulse } from "react-icons/fa6"
import Loader from "../../Loader"

type addNames = {
  setActivePage: (step: string) => void
}
const AddNames = ({ setActivePage }: addNames) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { currentCreatedEvent } = useAppSelector((state) => state.invite)
  console.log("currentCreatedEvent", currentCreatedEvent)
  const [namesInput, setNamesInput] = useState<string>("")
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    try {
      setLoading(true)

      // Split the input by commas or newlines to get the names
      const namesArray = namesInput
        .split(/\s*[,;|\n]\s*/g) // Split by comma, semicolon, or new line, allowing optional spaces
        .map((name) => name.trim())
        .filter((name) => name !== "") // Filter out any empty names

      // Create an array of objects with name and phone (phone is mocked here)
      const formattedNames: any = namesArray.map((name: any) => ({
        first_name: name ? name : "",
        last_name: "",
        suffix: "Mr",
        email: name,
        phone: name,
        quantity_members: "1",
      }))

      const totalData = {
        event_id: currentCreatedEvent?.event_id,
        contacts: formattedNames,
      }
      const contactAdded: any = await api?.contacts?.addGuest(totalData)
      console.log("contactAdded", contactAdded)
      console.log("formattedNames", formattedNames)
      setLoading(false)
      navigate(`/invite-details/${currentCreatedEvent?.event_id}`)
      // toast.success("Invite created successfully")

      // const contactAdded: any = await api?.contacts?.addContactNewArray(totalData)
    } catch {
      setLoading(false)
      toast.error("Error while adding contact")

      console.log("err")
    }
  }

  return (
    <div className="container d-flex flex-column">
      {loading ? (
        <Loader />
      ) : (
        <form className="d-flex flex-column" onSubmit={handleSubmit}>
          <div className="mb-3 " style={{ width: "80px" }}>
            <Link
              className="d-flex align-items-center reminders-page__link-container"
              to="/"
              onClick={() => dispatch(resetInvitationState())}
            >
              <IconArrowLeft />
              <span className="reminders-page__link-text">
                {t("buttons.backNew")}
              </span>
            </Link>
          </div>{" "}
          <div className=" d-flex justify-content-between">
            <h5 className="mb-3 fs-3 fw-bold">
              {/* {t("invitation.addNames")} */}
              Add Names
            </h5>{" "}
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center mt-4 mb-2 pb-2">
            <h5
              style={{
                position: "relative",
                paddingBottom: "8px", // Adjust for spacing between text and underline
              }}
              className="mb-2 pb-2"
            >
              Please <span style={{ color: "#20529B" }}>add </span>name or{" "}
              <span style={{ color: "#20529B" }} className="me-1">
                paste
              </span>
              them here. Separate each guest name with a line.
              <span
                style={{
                  content: '""',
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  height: "2px", // Thickness of the underline
                  width: "100%",
                  backgroundColor: "red", // Color of the underline
                }}
              />
            </h5>
            <div
              className="profile-input  rounded-sm text-dark d-flex -justify-content-center "
              style={{ width: "70%" }}
            >
              <style>
                {`
      input::placeholder {
        color: #d3d2d2;
        
      }
    `}
              </style>
              <textarea
                required
                placeholder="Add Guest name ....."
                value={namesInput}
                onChange={(e) => setNamesInput(e.target.value)}
                style={{
                  color: "#000000", // Text color
                  fontSize: "1rem",
                  paddingLeft: "20px",
                  paddingRight: "10px",
                  backgroundColor: "white",
                  borderRadius: "10px",
                  paddingTop: "20px",
                  paddingBottom: "7px",
                  border: "1px solid #ccc", // Optional: border styling
                  width: "100%",
                  resize: "vertical",
                  //   height: "100px", // Adjust height as needed
                }}
                rows={9} // Optional: Controls the default number of rows
              />
            </div>
          </div>
          <button
            type="submit"
            // onClick={(e) => onSubmit(e, "")}
            className="btn btn-dark"
            style={{
              width: "150px",
              height: "40px",
              borderRadius: "5px",
              backgroundColor: "#20529B",
              border: "none",
              marginLeft: "auto",
              marginTop: "20px",
            }} // Ensure it sticks to the bottom
          >
            {t("buttons.next")}
          </button>
        </form>
      )}

      {/* <ToastContainer
        style={{ width: "90%", maxWidth: "400px", fontSize: "18px" }}
      /> */}
    </div>
  )
}
export default AddNames
